interface IndexItem {
  icon: string;
  title: string;
  count: string;
}

const indexItems: IndexItem[] = [
  { icon: 'ri-star-line', title: '明星娱乐', count: '2,856条' },
  { icon: 'ri-live-line', title: '综艺八卦', count: '1,943条' },
  { icon: 'ri-user-smile-line', title: '网红动态', count: '1,672条' },
  { icon: 'ri-building-line', title: '商业内幕', count: '1,389条' },
  { icon: 'ri-movie-line', title: '影视资讯', count: '1,245条' },
  { icon: 'ri-music-line', title: '音乐圈瓜', count: '987条' },
  { icon: 'ri-gamepad-line', title: '电竞八卦', count: '856条' },
  { icon: 'ri-global-line', title: '海外吃瓜', count: '723条' },
  { icon: 'ri-lightbulb-line', title: '深度分析', count: '612条' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            吃瓜索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按类别快速找到你感兴趣的大瓜，总有一个频道适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-3 md:gap-4 max-w-4xl mx-auto">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="group flex items-center gap-3 bg-background-100 border border-background-200/70 rounded-xl p-3 md:p-4 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-accent-50 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-100 transition-colors">
                <i className={`${item.icon} text-lg text-accent-500`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-0.5">{item.count}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}